"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Technology = exports.Brand = exports.Carrier = void 0;
var Carrier;
(function (Carrier) {
    Carrier["OC"] = "OC";
    Carrier["LB"] = "LB";
    Carrier["NB"] = "NB";
    Carrier["OF"] = "OF";
    Carrier["ON"] = "ON";
    Carrier["HW"] = "HW";
    Carrier["UW"] = "UW";
    Carrier["UFL"] = "UFL";
    Carrier["RT"] = "RT";
    Carrier["WIR"] = "WIR";
    Carrier["SM"] = "SM";
    Carrier["SMP"] = "SMP";
})(Carrier = exports.Carrier || (exports.Carrier = {}));
var Brand;
(function (Brand) {
    Brand["HIS"] = "HIS";
    Brand["UNI"] = "UNI";
    Brand["FUZ"] = "FUZ";
    Brand["WIR"] = "WIR";
    Brand["QUA"] = "QUA";
    Brand["PRE"] = "PRE";
    Brand["JAM"] = "JAM";
    Brand["ARK"] = "ARK";
    Brand["BLM"] = "BLM";
})(Brand = exports.Brand || (exports.Brand = {}));
var Technology;
(function (Technology) {
    Technology["FTTP"] = "FTTP";
    Technology["FTTN"] = "FTTN";
    Technology["FTTH"] = "FTTH";
    Technology["HFC"] = "HFC";
    Technology["SAT"] = "SAT";
    Technology["WIR"] = "WIR";
    Technology["ETHERNET"] = "ETHERNET";
    Technology["FTTC"] = "FTTC";
    Technology["MBB"] = "MBB";
    Technology["FTTB"] = "FTTB";
    Technology["SMP"] = "SMP";
    Technology["VDSL"] = "VDSL";
})(Technology = exports.Technology || (exports.Technology = {}));
//# sourceMappingURL=enums.js.map